import React from 'react';
import {
  BooleanInput,
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';
import { Alert } from '@mui/material';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const EditInchargeStation = (props) => (
  <Permission permission={PERMISSIONS.UPDATE_STATION}>
    <Edit {...props} title="Editar carregador elétrico" redirect="list" mutationMode="pessimistic">
      <SimpleForm sx={{ maxWidth: 620 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          O código do QR não pode ser alterado — ele identifica o carregador no sistema da
          InCharge. Se o adesivo mudou, remova este e cadastre o novo.
        </Alert>

        {/* Só leitura: é a chave primária, e o app usa esse valor pra achar o posto. */}
        <TextInput source="code" label="Código do QR" disabled sx={{ minWidth: 300 }} />

        <ReferenceInput source="placeId" reference="stations" perPage={200} sort={{ field: 'name', order: 'ASC' }}>
          <SelectInput
            label="Posto"
            optionText="name"
            validate={[required()]}
            helperText="O posto define quantos pontos o cliente ganha por kWh."
            sx={{ minWidth: 300 }}
          />
        </ReferenceInput>

        <TextInput source="name" label="Identificação (opcional)" sx={{ minWidth: 300 }} />

        <BooleanInput
          source="isActive"
          label="Ativo"
          helperText="Desligado, o carregador para de abrir sessão — o cliente carrega, mas não pontua."
        />
      </SimpleForm>
    </Edit>
  </Permission>
);

export default EditInchargeStation;
